import {ColorClickHandler} from "./TrayPlacementTools.js"
import {TreeClickHandler} from "./TrayItemsClickedActions/TreeClickHandler.js"
import ABCyaPhaser from "@abcya/abcya_phaser";

export function TreeTab(Scene,Tray)
{
    const TreeBack = [];
    const TreeStroke = [];

    const TrayWidth = Tray.width;
    const TrayLeftX = Tray.getTopLeft().x;
    const NumOfButtons = 5;
    const Sections = TrayWidth/(NumOfButtons+1);
    var TrayArray = [];
    const ColorButtons = [];
    const DepthList = Scene.DepthList;
    const TrayOffset = 210;

    const text = Scene.add.text(234 - TrayOffset,15,ABCyaPhaser.Localization.instance.getLocalizedString("colors_label"),{fontFamily: 'fulbotano',color: 0x045613, fontSize: 26});

    TrayArray.push(text);

    TrayArray.push(Scene.addImage(238 - TrayOffset,70,"Line"));
    //subtracted 210 for TrayOffset
    for(let i = 1; i < 6;i++)
    {
        ////console.log(TrayLeftX);
        ColorButtons[i-1] = Scene.addImage(TrayLeftX+(i*Sections),43,"ClrSlct_Tree_"+i);
        ColorButtons[i-1].setInteractive();
        ColorButtons[i-1].on('pointerdown',ColorClickHandler,this);
    }

    TrayArray = TrayArray.concat(ColorButtons);

    for(let i in TrayArray)
    {
        TrayArray[i].setDepth(DepthList.OrnBack);
    }

    TreeBack[0] = Scene.addImage(Tray.x,193,"Tree_SlimBG");
    TreeBack[1] = Scene.addImage(Tray.x,418,"Tree_PntyBG");
    TreeBack[2] = Scene.addImage(Tray.x,651,"Tree_FlufBG");

    Scene.ColorGroup.addMultiple(TreeBack);

    TreeStroke[0] = Scene.addImage(Tray.x,193,"Tree_SlimStrk");
    TreeStroke[1] = Scene.addImage(Tray.x,418,"Tree_PntyStrk");
    TreeStroke[2] = Scene.addImage(Tray.x,651,"Tree_FlufStrk");

    Scene.OutlineGroup.addMultiple(TreeStroke);

    text.setOrigin(.5,.5);

    Scene.TrayGroup.addMultiple(TreeBack);
    Scene.TrayGroup.addMultiple(TreeStroke);
    Scene.TrayGroup.addMultiple(TrayArray);

    for (let x in TreeBack)
    {
        TreeBack[x].setScale(.40);
        TreeBack[x].setTint(0x045613);
        TreeBack[x].setInteractive();
        TreeBack[x].on('pointerdown',TreeClickHandler);
        TreeBack[x].setDepth(DepthList.OrnBack);
        TreeBack[x].treeStroke = TreeStroke[x];
    }

    for (let x in TreeStroke)
    {
        TreeStroke[x].setScale(.40);
        TreeStroke[x].setTint(0x03300B);
        TreeStroke[x].setDepth(DepthList.OrnMiddle);
    }
  
    //Scene.TrayGroup.clear(true,true);
}